import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryGrid() {
  return (
    <section className="py-10 md:py-14" aria-label="影视分类">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
            影视分类
          </h2>
          <Link
            to="/category/movie"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap transition-colors"
          >
            全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-background-200 transition-colors p-5 md:p-6 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${cat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-heading mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">
                {cat.slug === 'movie' && '院线大片 震撼视听'}
                {cat.slug === 'tv' && '热播剧集 每日更新'}
                {cat.slug === 'variety' && '爆笑综艺 欢乐不断'}
                {cat.slug === 'anime' && '热血国漫 精彩纷呈'}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}